import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  listProduction(customer_id, crop_id) {
    return RequesterV1.get(
      "open_queries/customer/basic_production_list/" +
        customer_id +
        "/" +
        crop_id
    );
  },
  getProductionDetails(container_id) {
    return RequesterV1.get(
      "open_queries/customer/basic_production_details/" + container_id
    );
  },
  downloadRepXlsx(producer_id, crop_id) {
    return RequesterV1.get(
      "open_queries/producer/basic_production_rep_xlsx/" +
        producer_id +
        "/" +
        crop_id,
      { responseType: "blob" }
    );
  },
};
